<div class="profile-content">
  <div class="tabs-container">
    <div class="tabs">
      <button (click)="setActiveTab('playlists')" [ngClass]="{'active': isTabActive('playlists')}" class="tab-button">
        <span class="tab-icon playlist-icon"></span>
        <span class="tab-text">Playlists</span>
      </button>
      <button (click)="setActiveTab('history')" [ngClass]="{'active': isTabActive('history')}" class="tab-button">
        <span class="tab-icon history-icon"></span>
        <span class="tab-text">History</span>
      </button>
      <button (click)="setActiveTab('insights')" [ngClass]="{'active': isTabActive('insights')}" class="tab-button">
        <span class="tab-icon insights-icon"></span>
        <span class="tab-text">Insights</span>
      </button>
      <button (click)="setActiveTab('settings')" [ngClass]="{'active': isTabActive('settings')}" class="tab-button">
        <span class="tab-icon settings-icon"></span>
        <span class="tab-text">Settings</span>
      </button>
    </div>
  </div>

  <div class="content-container">
    <!-- Content will be dynamically loaded based on selected tab -->
    @if (isTabActive('playlists')) {
      <div @fadeAnimation class="content-section">
        <!-- Playlists content -->
        <mypart-profile-content-playlists></mypart-profile-content-playlists>
      </div>
    }

    @if (isTabActive('history')) {
      <div @fadeAnimation class="content-section">
        <!-- History content -->
        <mypart-profile-content-history></mypart-profile-content-history>
      </div>
    }

    @if (isTabActive('insights')) {
      <div @fadeAnimation class="content-section">
        <!-- Insights content -->
        <mypart-profile-content-insights></mypart-profile-content-insights>
      </div>
    }

    @if (isTabActive('settings')) {
      <div @fadeAnimation class="content-section">
        <!-- Settings content -->
        <mypart-profile-content-settings></mypart-profile-content-settings>
      </div>
    }
  </div>
</div>
